import { useTranslation } from 'react-i18next';
import { AuctionDto } from '../../../services/Auction/auctionService.dto';
import { ItemInfoDto } from '../../../services/Item/itemService.dto';
import RectangularButton from '../../../components/buttons/RectangularButton';
import { useAuctionClose } from '../hooks/useAuctionClose';
import { useAuctionEdit } from '../hooks/useAuctionEdit';
import LoadingIndicator from '../../../components/loading/LoadingIndicator';
import AuctionEndInfo from './AuctionEndInfo';
import {
  DetailsGrid,
  DetailsTitle,
  DetailsValue,
  SectionContainer,
  SectionLeftColumn,
  SectionRightColumn,
} from './layoutComponents';

interface Props {
  refetchAuction: () => void;
  refetchAuctionAndItem: () => void;
  auction?: AuctionDto;
  item?: ItemInfoDto;
}

const AuctionDetails = ({ auction, item, refetchAuction, refetchAuctionAndItem }: Props) => {
  const { canEditAuction, showEditAuctionPopup } = useAuctionEdit(auction, refetchAuctionAndItem);
  const { canCloseAuction, requestAuctionClosure } = useAuctionClose(auction, refetchAuction);

  const { t } = useTranslation('onsite');

  if (!auction || !item) {
    return (
      <SectionContainer>
        <LoadingIndicator />
      </SectionContainer>
    );
  }

  return (
    <SectionContainer>
      <SectionLeftColumn>
        <DetailsGrid>
          <DetailsTitle>{`${t('auction.item-title')}:`}</DetailsTitle>
          <DetailsValue>{item.title}</DetailsValue>
          <DetailsTitle>{`${t('auction.item-id')}:`}</DetailsTitle>
          <DetailsValue>{item.id}</DetailsValue>
          <DetailsTitle>{`${t('auction.auction-id')}:`}</DetailsTitle>
          <DetailsValue>{auction.id}</DetailsValue>
          <DetailsTitle>{`${t('auction.auction-status')}:`}</DetailsTitle>
          <DetailsValue>{auction.status}</DetailsValue>
          <DetailsTitle>{`${t('auction.auction-end')}:`}</DetailsTitle>
          <AuctionEndInfo auction={auction} />
        </DetailsGrid>
      </SectionLeftColumn>
      <SectionRightColumn>
        <RectangularButton
          label={t('auction.edit-auction')}
          disabled={!canEditAuction}
          onClick={showEditAuctionPopup}
        />
        <RectangularButton
          label={t('auction.close-auction')}
          disabled={!canCloseAuction}
          onClick={requestAuctionClosure}
        />
      </SectionRightColumn>
    </SectionContainer>
  );
};

export default AuctionDetails;
